import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Building2 } from 'lucide-react';
import { CorporateInquiryForm } from '@/components/CorporateInquiryForm';

const MISSION = '#1A5276';
const TEAL = '#148F77';

export function CorporatePartnersPage(): JSX.Element {
  const [searchParams] = useSearchParams();

  const { selectedTier, selectedAmount } = useMemo(() => {
    const tier = searchParams.get('tier')?.trim() || searchParams.get('selectedTier')?.trim() || null;
    const amountRaw = searchParams.get('amount') ?? searchParams.get('selectedAmount');
    const amount =
      amountRaw != null && amountRaw !== '' && Number.isFinite(Number(amountRaw))
        ? Number(amountRaw)
        : null;
    return { selectedTier: tier, selectedAmount: amount };
  }, [searchParams]);

  return (
    <main>
      <section className="bg-white py-14 sm:py-20 border-b border-slate-100">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <p
            className="text-xs font-bold tracking-[0.38em] uppercase"
            style={{ color: MISSION }}
          >
            Corporate Partnerships
          </p>
          <h1 className="mt-3 text-3xl sm:text-5xl font-bold text-[#1C2833]">
            Partner with GSGO to expand CKD care.
          </h1>
          <p className="mt-4 max-w-3xl text-base sm:text-lg text-slate-600">
            Organizations can support emergency dialysis funding, patient education, and
            community-led programs across the Philippines. Share your goals and our team will
            follow up with tailored partnership options.
          </p>
        </div>
      </section>

      <section id="inquire" className="bg-[#F9FAFB] py-14 sm:py-20">
        <div className="max-w-3xl mx-auto px-4 sm:px-6">
          <div className="rounded-2xl border border-slate-200 bg-white p-6 sm:p-8 shadow-sm">
            <div className="flex items-center gap-3 mb-6">
              <span
                className="flex h-10 w-10 items-center justify-center rounded-lg"
                style={{ backgroundColor: `${TEAL}18`, color: TEAL }}
              >
                <Building2 size={20} />
              </span>
              <div>
                <h2 className="text-xl font-bold text-[#1C2833]">Partnership inquiry</h2>
                <p className="text-sm text-slate-600">
                  Complete the form below and we will respond within a few business days.
                </p>
              </div>
            </div>
            <CorporateInquiryForm
              source="partners_page"
              initialSelectedTier={selectedTier}
              initialSelectedAmount={selectedAmount}
            />
          </div>
        </div>
      </section>
    </main>
  );
}
